import styles from './Footer.module.css';

export function Footer() {
    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <div className={styles.brand}>
                    <img src="/logo.svg" alt="Atemoya" className={styles.logo} />
                </div>
                <div className={styles.brand}>
                    <span className={styles.studio}>Atemoya Games Studio</span>
                </div>
                <p className={styles.version}>v{__ATEMOYA_APPLICATION_VERSION__}</p>
                <p className={styles.copyright}>© 2026 Atemoya. All rights reserved.</p>
                <p className={styles.disclaimer}>Demo showcase. Play responsibly. 18+</p>
            </div>
        </footer>
    );
}
